import { createSelector } from 'reselect';

const selectTimekeeping = (state) => state.timekeepingState;

export const selectTimecards = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.timecards
);

export const selectTotalTimecardsCount = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.totalTimecardsCount
);

export const selectTimekeepingOverviewData = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.timekeepingOverviewData
);

export const selectIsTimecardsLoading = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.isTimecardsLoading
);

export const selectIsTimekeepingOverviewDataLoading = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.isTimekeepingOverviewDataLoading
);

export const selectIsReloadTimecards = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.isReloadTimecards
);

export const selectIsOverviewDataReload = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.isOverviewDataReload
);

export const selectIsDisputedTimecardUpdating = createSelector(
  selectTimekeeping,
  (timekeeping) => timekeeping.isDisputedTimecardUpdating
);
